import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /** Optional message to display within the overlay. */
  message?: string;
  /** If `true`, the overlay will be rendered with a border. */
  bordered?: boolean;
  /**
   * If `true`, the user will be able to try re-running the process that led to
   * the initial issue. If set to a string, the same button will be displayed,
   * but with its text content set to the value of the string.
   *
   * Note: when the "Retry" button is clicked, the `retry-requested` event is
   * emitted. This can be listened for and used to trigger the corresponding
   * process.
   */
  retriable?: boolean | string;
}

export interface Emits {
  // eslint-disable-next-line @typescript-eslint/prefer-function-type
  (event: 'retry-requested'): void;
}


import { computed } from 'vue';

import { faExclamationCircle } from '@icons/solid/faExclamationCircle';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    OverlayRenderIssue: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'OverlayRenderIssue' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: null,
    bordered: { type: Boolean },
    retriable: { type: [Boolean, String] }
  },
  emits: ["retry-requested"],
  setup(__props: any) {

const prop = __props as {
  /** Optional message to display within the overlay. */
  message?: string;
  /** If `true`, the overlay will be rendered with a border. */
  bordered?: boolean;
  /**
   * If `true`, the user will be able to try re-running the process that led to
   * the initial issue. If set to a string, the same button will be displayed,
   * but with its text content set to the value of the string.
   *
   * Note: when the "Retry" button is clicked, the `retry-requested` event is
   * emitted. This can be listened for and used to trigger the corresponding
   * process.
   */
  retriable?: boolean | string;
};

/**
 * `OverlayRenderIssue` component properties.
 */




const retryButton = computed(() => {
  if (!prop.retriable) return null;

  const text = typeof prop.retriable === 'string' ? prop.retriable : 'Retry';

  return { text };
});

return { __sfc: true,prop, retryButton, faExclamationCircle }
}

})